var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalloon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.351,
    height: 179.312,
    viewBox: "0 0 140.351 179.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_577",
    "data-name": "Grupo 577",
    opacity: 0.524
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_354",
    "data-name": "Grupo 354",
    transform: "translate(0 10.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2228",
    "data-name": "Caminho 2228",
    d: "M230.936,180.562a19.705,19.705,0,0,1-19.976,32.189l-1.712-.486-1,1.472a32.408,32.408,0,0,1-57.751-8.748l-1.183-3.86-2.895,2.824a19.7,19.7,0,1,1-25.871-29.64l1.93-1.507-1.5-1.944a32.052,32.052,0,0,1-6.762-19.8,32.425,32.425,0,0,1,43.79-30.344l1.79.676,1.1-1.564a45.406,45.406,0,1,1,70.077,57.37l-1.578,1.662Z",
    transform: "translate(-112.969 -100.525)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2229",
    "data-name": "Caminho 2229",
    d: "M289.114,330.4a5.153,5.153,0,1,1-5.15-5.156A5.162,5.162,0,0,1,289.114,330.4Z",
    transform: "translate(-161.997 -166.96)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_17",
    "data-name": "Elipse 17",
    cx: 10.002,
    cy: 10.002,
    r: 10.002,
    transform: "translate(96.723 125.961)",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_358",
    "data-name": "Grupo 358",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_355",
    "data-name": "Grupo 355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2230",
    "data-name": "Caminho 2230",
    d: "M186.417,222.53a37.124,37.124,0,0,1-34.467-22.941,24.634,24.634,0,0,1-31.317-37.881,36.925,36.925,0,0,1-6.417-20.929,37.358,37.358,0,0,1,48.679-35.574A50.339,50.339,0,1,1,240.955,168.7a24.642,24.642,0,0,1-24.706,38.938A37.312,37.312,0,0,1,186.417,222.53Zm-32.174-31.684,1.186,3.866a32.41,32.41,0,0,0,57.753,8.743l1-1.468,1.709.487a19.7,19.7,0,0,0,19.976-32.192l-1.543-1.7,1.578-1.662a45.408,45.408,0,1,0-70.081-57.373l-1.1,1.561-1.786-.673a32.4,32.4,0,0,0-37.03,50.145l1.5,1.94-1.933,1.511a19.7,19.7,0,1,0,25.873,29.635Z",
    transform: "translate(-112.969 -85.312)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_356",
    "data-name": "Grupo 356",
    transform: "translate(96.723 125.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2231",
    "data-name": "Caminho 2231",
    d: "M265.222,294.008a14.934,14.934,0,1,1,14.934-14.934A14.951,14.951,0,0,1,265.222,294.008Zm0-24.937a10,10,0,1,0,10,10A10.015,10.015,0,0,0,265.222,269.071Z",
    transform: "translate(-250.288 -264.14)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_357",
    "data-name": "Grupo 357",
    transform: "translate(116.811 158.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2232",
    "data-name": "Caminho 2232",
    d: "M288.894,330.206a10.085,10.085,0,1,1,10.084-10.085A10.1,10.1,0,0,1,288.894,330.206Zm0-15.24a5.155,5.155,0,1,0,5.154,5.155A5.162,5.162,0,0,0,288.894,314.966Z",
    transform: "translate(-278.808 -310.035)",
    fill: "#161615"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.f8fcb92de6346970a8751cca94794e5c.svg";
export { ForwardRef as ReactComponent };